import { SERVER_API } from "../../Constant";
import axios from "axios";

export const AddCustomers = async (data: any) => {
  try {
    const formData = new FormData();
    formData.append("inputs", JSON.stringify(data));
    const response = await axios.post(
      `${SERVER_API}/Customers/add_customer_details.php`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    console.error("Add customers failed:", error);
    return { error: "Add customers failed" };
  }
};
